import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-6 h-6 mr-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), _mergeProps(_ctx.$attrs, {
    type: _ctx.type,
    class: [
      _ctx.colorClasses,
      _ctx.sizeClasses,
      { 'flex items-center space-x-4': _ctx.$slots.icon },
      {'flex items-center cursor-wait': _ctx.isLoading},
      {'opacity-70': _ctx.disabled },
      { 'cursor-pointer': !_ctx.disabled }
    ],
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClick($event))),
    disabled: _ctx.disabled,
    "aria-disabled": _ctx.disabled
  }), {
    default: _withCtx(() => [
      (_ctx.$slots.icon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "icon")
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default"),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(_ctx.loaderClasses)
          }, null, 2))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 16, ["type", "class", "disabled", "aria-disabled"]))
}